/**
 * Every audio file the game loads, in one place: swapping a sound (or a whole pack) only means
 * changing a path here. Licenses and provenance: public/audio/CREDITS.md.
 */
export const AMBIENT = {
  birdsong: { path: 'audio/ambient/birdsong.mp3', volume: 0.32 },
  // Halved (owner, 2026-10-02): a light breeze under the birdsong, not over it.
  breeze: { path: 'audio/ambient/breeze.mp3', volume: 0.11 },
} as const;

/**
 * At night (Lights Out): no birdsong, and the breeze picks up (owner, 2026-10-04: doubled, to
 * fill the space the birds leave).
 */
export const NIGHT_VOLUME: Readonly<Record<keyof typeof AMBIENT, number>> = {
  birdsong: 0,
  breeze: 0.22,
};

export const SFX = {
  coin: { path: 'audio/sfx/coin.mp3', volume: 0.35 },
  pickup: { path: 'audio/sfx/pickup.mp3', volume: 0.35 },
  rare: { path: 'audio/sfx/rare.mp3', volume: 0.4 },
  bump: { path: 'audio/sfx/bump.mp3', volume: 0.45 },
  squeak: { path: 'audio/sfx/squeak.mp3', volume: 0.25 },
  click: { path: 'audio/sfx/click.mp3', volume: 0.3 },
  complete: { path: 'audio/sfx/complete.mp3', volume: 0.4 },
  star: { path: 'audio/sfx/star.mp3', volume: 0.35 },
  rake: { path: 'audio/sfx/rake.mp3', volume: 0.4 },
  deny: { path: 'audio/sfx/deny.mp3', volume: 0.2 },
} as const;

export type SfxKey = keyof typeof SFX;
export type AmbientKey = keyof typeof AMBIENT;

export const audioKey = (name: string) => `audio:${name}`;
